<template>
    <header class="app-header">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div class="container">
                <router-link class="navbar-brand" to="/">
                    <div class="animated-logo">
                        <span>S</span>
                        <span>e</span>
                        <span>l</span>
                        <span>a</span>
                        <span>m</span>
                        <span>&nbsp;</span>
                        <span>R</span>
                        <span>a</span>
                        <span>c</span>
                        <span>h</span>
                        <span>u</span>
                        <span>n</span>
                        <span>k</span>
                        <span>o</span>
                        <span>w</span>
                        <span>o</span>
                        <span>ś</span>
                        <span>ć</span>
                    </div>
                </router-link>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav ms-auto">
                        <li class="nav-item">
                            <router-link class="nav-link" to="/">Strona główna</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/oferta">Oferta</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/cennik">Cennik</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/kontakt">Kontakt</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link btn btn-primary text-white ms-2" to="/strefa-klienta">
                                Strefa Klienta
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    name: 'AppHeader'
}
</script>

<style lang="scss" scoped>
.app-header {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    position: sticky;
    top: 0;
    z-index: 1000;

    .navbar-brand {
        font-size: 1.5rem;
        color: var(--primary-color);
    }

    .animated-logo {
        display: inline-block;
        position: relative;
        font-weight: 700;

        span {
            display: inline-block;
            position: relative;

            // Efekt podświetlenia po najechaniu
            &:hover {
                color: var(--secondary-color);
                transform: translateY(-2px);
                transition: all 0.2s ease;
            }

            // Efekt animowanego wejścia przy ładowaniu strony
            animation: logoAppear 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
            opacity: 0;

            @for $i from 1 through 18 {
                &:nth-child(#{$i}) {
                    animation-delay: #{$i * 0.05}s;
                }
            }

            // Dodaj efekt podkreślenia
            &::after {
                content: '';
                position: absolute;
                width: 0;
                height: 2px;
                bottom: -2px;
                left: 0;
                background-color: var(--secondary-color);
                transition: width 0.3s ease;
            }

            &:hover::after {
                width: 100%;
            }
        }
    }

    @keyframes logoAppear {
        0% {
            opacity: 0;
            transform: translateY(10px) rotateX(90deg);
        }

        100% {
            opacity: 1;
            transform: translateY(0) rotateX(0);
        }
    }

    .nav-link {
        font-weight: 500;
        transition: color 0.3s ease;

        &:hover {
            color: var(--secondary-color);
        }

        &.router-link-exact-active {
            color: var(--secondary-color);
        }
    }
}
</style>